import React, {useEffect, useState} from 'react';

import {Autocomplete, TextField} from '@mui/material';
import {getOptionSelect} from '../../Services/OptionSelect';

export default function SelectForm({
  data,
  handleChange,
  dependencyFilter,
  valueField,
  _serialNumber,
}) {
  const [option, setOption] = useState([]);
  const [dataAll, setDataAll] = useState([]);
  const [dataFilterDependency, setDataFilterDependency] = useState([]);
  const [numberRegister] = useState(
    process.env.REACT_APP_NUMBER_SELECT_OPTIONS,
  );
  const [clearState, setClearState] = useState(false);

  async function getData() {
    if (data.tipo === 'tabla') {
      await getOptionSelect(data.servicio, data.filtro).then(async response => {
        let dataFull = response.data;
        if (data.busExacta === '1') {
          dataFull = await response.data.filter(
            item => item?.codigo?.length > 0 && item.codigo,
          );
        }
        setDataAll(dataFull);
        // If busExacta is "1", don't show initial options (force search)
        if (data.busExacta === '1') {
          setOption([]);
        } else {
          setOption(dataFull.slice(0, numberRegister));
        }
      });
    } else {
      const dataFull = data.opciones;
      setDataAll(dataFull);
      setOption(dataFull);
    }
  }

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function filterItemByOtherField(returnInfo) {
    let dataFilter = dependencyFilter?.[data.id];
    const validateClient = dataFilter?.find(
      item => item.key === 'id_tercero',
    )?.value;
    if (!validateClient && data.item === 'Equipo') {
      dataFilter.shift();
    }

    const dataFilterOther = await dataAll.filter(item => {
      let condicion = true;
      dataFilter?.forEach(itemData => {
        if (item[itemData.key] !== itemData.value) {
          condicion = false;
        }
      });
      return condicion;
    });
    setDataFilterDependency(dataFilterOther);
    if (returnInfo) return dataFilterOther;
    // If busExacta is "1", don't show initial options (force search)
    if (data.busExacta === '1') {
      setOption([]);
    } else {
      setOption(dataFilterOther.slice(0, numberRegister));
    }
  }

  useEffect(() => {
    if (dependencyFilter?.[data.id]) {
      filterItemByOtherField();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dependencyFilter, dataAll]);

  const filterItem = async e => {
    const searchValue = e?.toString().trim();

    if (!searchValue) {
      // If busExacta is "1", keep options empty when input is cleared
      if (data.busExacta === '1') {
        setOption([]);
        return;
      }

      const dataToUse =
        dataFilterDependency?.length > 0 ? dataFilterDependency : dataAll;
      setOption(dataToUse.slice(0, numberRegister));
      return;
    }

    const FILTER_METHODS = {
      1: 'opcion',
      2: 'codigo',
      3: 'ambos',
    };

    // Determine filter method from API's tipoBusqueda property
    const getFilterMethod = () => {
      const searchType = data.tipoBusqueda ?? 1;
      return FILTER_METHODS[searchType];
    };

    const itemOption = getFilterMethod();
    const normalize = text => text?.toUpperCase() ?? '';
    const isExactMatch = data.busExacta === '1';

    const filterByBoth = (item, exact = false) => {
      const searchTerm = normalize(searchValue);
      const codigoMatch = normalize(item.codigo);
      const opcionMatch = normalize(item.opcion);

      if (exact) {
        return codigoMatch === searchTerm || opcionMatch === searchTerm;
      }

      return (
        codigoMatch.includes(searchTerm) || opcionMatch.includes(searchTerm)
      );
    };

    const filterByField = (item, exact = false) => {
      const itemValue = normalize(item[itemOption]);
      const searchTerm = normalize(searchValue);
      return exact ? itemValue === searchTerm : itemValue.includes(searchTerm);
    };

    const fullData =
      dataFilterDependency?.length > 0 ? dataFilterDependency : dataAll;
    const isBothMethod = itemOption === FILTER_METHODS[3]; // "ambos"

    const dataResult = fullData?.filter(item =>
      isBothMethod
        ? filterByBoth(item, isExactMatch)
        : filterByField(item, isExactMatch),
    );

    setOption(dataResult?.slice(0, numberRegister) ?? []);
  };

  const updateClearState = () => {
    if (clearState) {
      setClearState(false);
    }
  };
  const getKeyUpdate = () => {
    if (
      clearState &&
      (Object.keys(valueField).length === 0 || valueField[data.id] === null)
    ) {
      return Math.random() * 1000;
    }
    //return 1
  };
  const setItemOnFocus = () => {
    if (option.length === 0) {
      //filterItemByOtherField();
      if (!dependencyFilter?.[data.id]) {
        getData();
      }
    }
  };
  //const selectedOption = option.find(opt => opt.id === valueField[data.id]) || null;
  function filterByParameter() {
    if (
      data.id === 'id_departamentoSolicitud' ||
      data.id === 'id_medioSolicitud'
    ) {
      return (
        data.opciones.find(
          item => item.id === parseInt(data?.parametro?.valor),
        ) || null
      );
    }
    const findOptionByQuery =
      dataAll.find(opt => opt.id === parseInt(data?.parametro?.valor)) || null;
    return findOptionByQuery;
  }

  let selectedOption;
  if (data.id === 'id_sucursal') {
    selectedOption =
      dataAll.find(opt => opt.id === valueField[data.id]) || null;
  } else {
    selectedOption = option.find(opt => opt.id === valueField[data.id]) || null;
  }
  return (
    <>
      <Autocomplete
        key={getKeyUpdate()}
        id={'combo-box-demo' + data.id}
        options={option}
        onInputChange={(event, _newValue) => {
          if (event && event.type === 'change') {
            filterItem(event.target.value);
          }
        }}
        getOptionLabel={option => option.opcion}
        disabled={
          data?.parametro?.opcion === 'ver' && data?.parametro?.valor
            ? true
            : false
        }
        value={data?.parametro?.valor ? filterByParameter() : selectedOption}
        onChange={(event, newValue) => {
          setClearState(true);
          handleChange(newValue?.id, data.id);
        }}
        filterOptions={(options, state) => {
          if (data.busExacta === 1) {
            return options.filter(
              item =>
                String(item.codigo).toLowerCase() ===
                state.inputValue.toLowerCase(),
            );
          }
          return options;
        }}
        onOpen={setItemOnFocus}
        renderInput={params => {
          return (
            <TextField
              onFocus={updateClearState}
              {...params}
              label={data.item + (data?.obligatorio ? ' *' : '')}
            />
          );
        }}
      />
    </>
  );
}
